import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          none_negative_carryover: {
            change_history: {
              header: 'HEADER',
              close: 'CLOSE',
            },
          },
        },
      },
    },
  }));
}
